import { useRequest } from 'ahooks';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { Button, ButtonWithArrowRight, Grid, Modal } from '~components';
import Header from '~components/dumbs/Header';
import { CreditApproved, CreditAnalysis, CreditReproved } from '~containers';
import { useLayout } from '~hooks';
import { Onboarding } from '~services';

import * as Styled from './Credit.styled';
import { TStatus } from './Credit.types';
import LoadingSpinner from './LoadingSpinner';
import * as amplitude from '@amplitude/analytics-browser';

function Credit() {
  const [status, setStatus] = useState('');
  const [openModal, setOpenModal] = useState(false);

  const { setLayout } = useLayout();
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const onboardingId = searchParams.get('id');

  const { loading } = useRequest(Onboarding.getCreditInfo, {
    defaultParams: [onboardingId],
    onSuccess: (response) => {
      const status = response?.data?.credit;
      setStatus(status);
      amplitude.track({
        event_type: 'credit_limit_result_loaded',
        event_properties: {
          credit_limit_status: status,
        },
      });
    },
  });

  const {
    runAsync: updateOnboardingStatus,
    loading: loadingUpdateOnboardingStatus,
  } = useRequest(Onboarding.updateOnboardingStatus, {
    manual: true,
  });

  const modalPrimaryButton = {
    text: 'Cancelar',
    onClick: handleModalClose,
  };

  const modalSecondaryButton = {
    text: 'Sim, quero voltar',
    onClick: handleModalConfirm,
  };

  function handleOnBack() {
    setOpenModal(true);
  }

  async function handleOnNext() {
    await updateOnboardingStatus(onboardingId);
    navigate(`../representantes/cadastrar?id=${onboardingId}`);
  }

  function handleModalClose() {
    setOpenModal(false);
  }

  function handleModalConfirm() {
    navigate(`/`);
  }

  useEffect(() => {
    setLayout({
      header: {
        position: 'left',
      },
    });
  }, [setLayout]);

  return (
    <>
      <Styled.Wrapper>
        <Styled.WrapperContent displayBanner={!loading}>
          <Header logoPosition="left" />
          {loading && <LoadingSpinner />}
          {!loading && (
            <Grid container direction="column">
              <Grid>
                {status === TStatus.ANALYSIS && <CreditAnalysis />}
                {status === TStatus.APPROVED && <CreditApproved />}
                {status === TStatus.REPROVED && <CreditReproved />}
              </Grid>
              <Grid>
                <Styled.Footer>
                  <Button variant="tertiary" onClick={handleOnBack}>
                    Voltar
                  </Button>
                  <ButtonWithArrowRight
                    variant="primary"
                    onClick={handleOnNext}
                    loading={loadingUpdateOnboardingStatus}
                  >
                    Continuar
                  </ButtonWithArrowRight>
                </Styled.Footer>
              </Grid>
            </Grid>
          )}
        </Styled.WrapperContent>
        {!loading && <Styled.RightSide />}
      </Styled.Wrapper>

      <Modal
        open={openModal}
        onClose={handleModalClose}
        title="Realmente deseja voltar?"
        message="Ao voltar, você terá que entrar novamente com o CNPJ para seguir com a abertura da sua Conta PJ Fretebras. "
        buttons={[modalSecondaryButton, modalPrimaryButton]}
      />
    </>
  );
}

export default Credit;
